<!-- @author zhengjie -->
<template>
  <div class="icon-body">
    <Input v-model="name" suffix="ios-search" style="position: relative;" clearable placeholder="请输入图标名称" @on-clear="filterIcons" @on-change="filterIcons">
    </Input>
    <div class="icon-list">
      <div v-for="(item, index) in iconList" :key="index" @click="selectedIcon(item)">
        <i class="r-icon icon iconfont" :class="'icon'+item"></i>
        <span class="r-span">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
    import icons from './requireIcons'
    export default {
        name: 'IconSelect',
        data () {
            return {
                name: '',
                iconList: icons
            }
        },
        methods: {
            filterIcons () {
                if (this.name) {
                    this.iconList = icons.filter(item => item.includes(this.name))
                    console.log(this.iconList)
                } else {
                    this.iconList = icons
                }
            },
            selectedIcon (name) {
                this.$emit('selected', name)
                document.body.click()
            },
            reset () {
                this.name = ''
                this.iconList = icons
            }
        }
    }
</script>

<style lang="less" scoped>
  .icon-body {
    width: 100%;
    padding: 10px;
    .icon-list {
      height: 200px;
      overflow-y: scroll;
      div {
        height: 30px;
        line-height: 30px;
        margin-bottom: -5px;
        cursor: pointer;
        width: 33%;
        float: left;
      }
      span {
        display: inline-block;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
      }
      .r-icon{
        vertical-align: middle;
        display: inline-block;
        margin-right:5px;
      }
      .r-span{
        vertical-align: middle;
        display: inline-block;
        width: 97px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IconSelect/index.vue